import { removeSessionStorage } from '../util';

const RATE_ERROR_MESSAGE = 'rateErrorMessage';

export function setRateErrorMessageInStorage(value) {
  sessionStorage.setItem(RATE_ERROR_MESSAGE, value);
}

export function removeRateErrorMessageInStorage() {
  removeSessionStorage(RATE_ERROR_MESSAGE);
}

export function getRateErrorMessageInStorage() {
  return sessionStorage.getItem(RATE_ERROR_MESSAGE);
}
